<nx-dialog [dialogData]="data">
  <div class="dialog-content">{{ data.content }}</div>
  <button mat-raised-button color="primary" class="dialog-actions" (click)="confirmAction()">Ja</button>
  <button mat-raised-button color="warn" class="dialog-actions" (click)="denyAction()">Nein</button>
</nx-dialog>
